<template>
    <v-card style="height: 100%; display: flex; flex-direction: column;" >
        <v-card-title>
            {{ types[type] }} (6 Meses)

            <v-spacer></v-spacer>

            <v-btn 
                outlined
                small
                @click="getValues" 
            >
                <i class="fas fa-sync-alt"></i>
            </v-btn>
        </v-card-title>
        <v-card-text style="height: 100%;" >
            <bar-graph :options="graph.options" :chart-data="graph.chartData" v-if="!overlay" style="height: 100%" />

            <v-overlay 
                :value="overlay"
                absolute
            >
                <v-progress-circular
                    size="100"
                    color="indigo"
                >
                </v-progress-circular>
            </v-overlay>
        </v-card-text>
        <v-card-actions>
			Total: <strong> {{formater(total)}}</strong>
        </v-card-actions>
    </v-card>
</template>
<script>
import { barGraph } from '@/components/graphics/'
import helper from "@/mixins/helper"
import numeric from "@/mixins/numeric"
import { mapGetters } from 'vuex'

const Months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
]

const types = {
	pay: 'Contas a pagar',
	paid: 'Contas pagas',
	receive: 'Contas a receber',
	received: 'Contas recebidas'
}

export default {
    components: {
        barGraph
    },

    mixins: [helper, numeric],

	props: {
		type: {
			require: true,
			type: String
		},
		color: {
			require: true,
			type: String
		}
	},

    data(){
        return {
            total: 0,
            period: {
                type: 'Meses',
                value: 6,
                service: 'months',
                label: 'mes'
            },
            graph: {
                chartData: {
                    labels: [],
                    datasets: [{
                        label: 'Valor',
                        backgroundColor: this.color,
                        data: [],
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: (tooltipItem, data) => data.labels[tooltipItem.index]
                        }
                    }  
                }
            },
            overlay: false,
			types: types
        }
    },
    
    computed: {
        ...mapGetters({
            userToken: 'token',
            franchiseID: 'franchiseId'
        })
    },

    methods: {
        async getValues(){
            this.overlay = true
            this.total = 0
            const response = await this.getData(`${process.env.VUE_APP_API}/graphs/generics/bills/${this.type}/6`, {
                method: 'GET',
                headers: new Headers({
                    'Authentication': this.userToken,
                    'Franchise': this.franchiseID,
                    'franchiseToken': this.$store.getters.franchiseToken
                })
            })

            if (response.data){
                let labels = []
                let datasets = []

                response.response.forEach(({ vencimento, quantidade, ano, valor }) => {
                    this.total = parseFloat(this.total) + parseFloat(valor)
                    
                    labels.push(`${Months[vencimento - 1]}/${ano} - ${quantidade}`)
                    datasets.push(valor)
                })

                this.graph.chartData.labels = labels
                this.graph.chartData.datasets[0].data = datasets
            } else {
                this.$root.$on('show-exception-alert', response.message)
            }

            this.overlay = false
        }
    },
    mounted(){
        this.getValues()

        this.$root.$on('reload-all-franchise-graphs', () => {
            this.getValues()
        })
    }
}
</script>
